import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './EmptyEmail.css';

class EmptyEmail extends React.Component {
  static handleValidEmail() {
    document.getElementById('emailerror').style.display = 'none';
    document.getElementById('email').style.border = '2px solid #ccc';
  }

  static handleInvalidEmail() {
    document.getElementById('emailerror').style.display = 'block';
    document.getElementById('email').style.border = '0.05rem solid #d0021b';
  }

  constructor(props) {
    super(props);

    if (
      props.email !== undefined &&
      props.email !== null &&
      props.email.length > 0
    ) {
      this.state = { email: props.email };
    } else {
      this.state = { email: '' };
    }

    this.onEmailChange = this.onEmailChange.bind(this);
  }

  onEmailChange(event) {
    this.state = {
      email: event.target.value,
    };

    if (this.state.email.length > 0) {
      // Make sure email is valid before letting the user proceed.
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (emailRegex.test(this.state.email)) {
        EmptyEmail.handleValidEmail();
      } else {
        EmptyEmail.handleInvalidEmail();
      }
    }
    this.props.onChanged();
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <p>Email address</p>
        <div className={styles.noSavedEmail}>
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Email"
            onChange={this.onEmailChange}
            defaultValue={this.state.email}
          />
          <p className={styles.errorText} id="emailerror">
            Please enter a valid email address.
          </p>
        </div>
      </div>
    );
  }
}

EmptyEmail.propTypes = {
  email: PropTypes.string,
  onChanged: PropTypes.func,
};

export default EmptyEmail;



// WEBPACK FOOTER //
// ./src/containers/CartPage/EmptyEmail.jsx